<mat-expansion-panel hideToggle #filterPanel>
  <mat-expansion-panel-header class="header">
    <mat-panel-title class="truncated">
      {{ column.field.displayValue | translate }}&nbsp;

      <strong *ngIf="filter?.operator">
        {{ filter?.operator | formatOperator: {column: column} }}&nbsp;
      </strong>

      <ng-container *ngIf='column.editTemplate !== "date"; else date'>
        <i *ngIf="(filter?.value | formatValue: { column: column }) || filter?.value === 0">
          {{ filter?.value | formatValue: {column: column} | subtypeConverter | translate }}
        </i>

        <i *ngIf="filter?.tags?.length && !filter?.value && filter?.value !== 0">
          {{ filter?.tags | formatValue: {column: column} | translate }}
        </i>

        <i *ngIf="filter?.list?.length && !filter?.value && filter?.value !== 0">
          {{ filter?.list | formatValue: {column: column} | translate }}
        </i>
      </ng-container>

      <ng-container *ngIf="column.editTemplate === 'query'">
        <i *ngFor="let value of filter?.values; index as i">
          {{ value.parentName }}{{ i < filter?.values.length - 1 ? ', ' : '' }}
        </i>
      </ng-container>

      <ng-container *ngIf="filter?.operator === 'range'">
        <ng-container *ngIf="column.editTemplate === 'date'">
          <i *ngIf="filter?.secondValue">
            &nbsp;-&nbsp;{{ filter?.secondValue | date: 'MM-dd-yyyy' }}
          </i>
        </ng-container>
        <ng-container *ngIf="column.editTemplate !== 'date'">
          <i *ngIf="filter?.secondValue">&nbsp;-&nbsp;{{ filter?.secondValue }}</i>
        </ng-container>
      </ng-container>
      <div
        *ngIf="showAdd"
        [matTooltip]="'RUBIC_CUBE.ADD_SAME_ATTRIBUTE' | translate"
        (click)="addCombined($event)"
        class="plus-icon">
        +
      </div>
    </mat-panel-title>
    <q9-icon-button icon="edit"></q9-icon-button>
    <q9-icon-button
      icon="delete-def"
      (click)="$event.preventDefault(); delete.emit()"></q9-icon-button>
  </mat-expansion-panel-header>

  <ng-container *ngIf="filterPanel.expanded">
    <app-edit-filter-form
      [action]="'edit'"
      [filterControl]="filterControl"
      [filter]="filter"
      [columns]="[column]"></app-edit-filter-form>
  </ng-container>
</mat-expansion-panel>

<ng-template #date let-context="date">
  <i>{{ filter?.value | date: 'MM-dd-yyyy' }}</i>
</ng-template>
